// extracted by mini-css-extract-plugin
module.exports = {"pagePanel":"PagePanel_pagePanel__2j0lE"};